import React,{useState,useEffect} from 'react'
import './AllUsersControl.css'
import {collection,getDocs,updateDoc,doc} from 'firebase/firestore'
import {db} from '../../../firebase/Config'
import LoadingForAll from '../../../Components/Loading/Loading'
function AllUsersControl() {
    const [users,setUsers]=useState([])
    const [loading,setLoading]=useState(true)
    const [error,setError]=useState(null)

    useEffect(()=>{
        const fetchUsers=async()=>{
            setLoading(true)
            try{
                const usersRef=collection(db,'users')
                const querySnapshot=await getDocs(usersRef)
                const usersData=querySnapshot.docs.map(doc=>({
                    id:doc.id,  
                    ...doc.data()
                }))
                usersData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setUsers(usersData)
               
                setLoading(false)
            }catch(error){
                setError(error.message)
                setLoading(false)
            }
        }
        fetchUsers()
    },[])

    const handleSetAdmin=async(userId)=>{
        try{
            const userRef=doc(db,'users',userId)
            await updateDoc(userRef,{isAdmin:true})
            setUsers(prevUsers=>prevUsers.map(user=>user.id===userId?{...user,isAdmin:true}:user))
        }catch(error){
            setError(error.message)
        }
    }

    const handleSetUser=async(userId)=>{
        try{
            const userRef=doc(db,'users',userId)
            await updateDoc(userRef,{isAdmin:false})
            setUsers(prevUsers=>prevUsers.map(user=>user.id===userId?{...user,isAdmin:false}:user))
        }catch(error){
            setError(error.message)
        }
    }
    
    {loading && <LoadingForAll title="Loading All Users..."/>}
    {error && <div className="error-message">{error}</div>}
    {users.length>0 && (
        <div>
            <h2>No users found</h2>
        </div>
    )}
  return (
    <div>
         <div className="container">
        <div className="text-center mt-3" >
            <h1 className="section-title title-all-users">
               User Management
            </h1>
        </div>
        
        <div className="table-responsive">
            <table className="table user-table table-striped">
                <thead>
                    <tr>
                        <th scope="col"> </th>
                        <th scope="col"> Phone Number</th>
                        <th scope="col"> Name</th>
                        <th scope="col"> Email</th>
                        <th scope="col"> User / Admin</th>
                        <th scope="col"> Set Admin</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user,index)=>(
                    <tr>    
                        <th scope="row"> {index+1}</th>
                        <td class="user-id">{user.phone}</td>
                        <td class="user-name">{user.username}</td>
                        <td class="user-email">{user.email}</td>
                        <td class="user-admin">{user.isAdmin ? 'Admin' : 'User'}</td>
                        {!user.isAdmin ? <td class="user-admin">
                            <button className="btn btn-primary" onClick={()=>handleSetAdmin(user.id)}>Set as Admin</button>
                        </td> : <td class="user-admin">
                            <button className="btn btn-primary" onClick={()=>handleSetUser(user.id)}>Set as User</button>
                        </td>}
                    </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
    </div>
  )
}

export default AllUsersControl